import { IFood, IFoodMeasure, IFoodPartial } from '../../interfaces/food';

const BASE_WEIGHT = 100

export class FoodPartial implements IFoodPartial {
  category: string;
  categoryLabel: string;
  foodId: string;
  image: string;
  label: string;
  nutrients: {
    ENERC_KCAL: number;
    PROCNT: number;
    FAT: number;
    CHOCDF: number;
    FIBTG: number;
  };

  constructor(item: IFoodPartial) {
    Object.keys(item).forEach((key) => {
      if (key === 'nutrients') {
        this.setNutrients(item[key]);
      } else {
        this[key] = item[key as keyof FoodPartial];
      }
    });
  }

  setNutrients(nutrients: any) {
    this.nutrients = {
      ENERC_KCAL: 0,
      PROCNT: 0,
      FAT: 0,
      CHOCDF: 0,
      FIBTG: 0,
    }
    Object.keys(nutrients).map((nutrient) => {
      this.nutrients[nutrient] = nutrients[nutrient].toFixed(1);
    });
  }

  calculateNutrient(nutrient: string, measureWeight: number = 1, weight: number = BASE_WEIGHT): string {
    const value = (this.nutrients[nutrient] / BASE_WEIGHT * measureWeight * weight)
    return value ? value.toFixed(1) : '-'
  }
}

export class FoodMeasure implements IFoodMeasure {
  label: string;
  uri: string;
  weight: number;

  constructor(item: IFoodMeasure) {
    Object.keys(item).forEach((key) => {
      return (this[key] = item[key as keyof FoodMeasure]);
    });
  }
}

export class FoodMeasures {
  measures: IFoodMeasure[];

  constructor(items: IFoodMeasure[]) {
    this.measures = items.map((measure) => new FoodMeasure(measure));
  }
}

export class Food implements IFood {
  food: IFoodPartial;
  measures: IFoodMeasure[];

  constructor(item: IFood) {
    Object.keys(item).forEach((key) => {
      if (key === 'measures') {
        this[key] = new FoodMeasures(item[key]).measures;
      } else {
        this[key] = new FoodPartial(item[key]);
      }
    });
  }
}

export class Foods {
  foods: Food[];

  constructor(items: IFood[]) {
    this.foods = items.map((food) => new Food(food));
  }
}

